// Categorização de tipos de manutenção em categorias técnicas
export type MaintenanceCategory = 
  | 'mechanical'
  | 'tire'
  | 'suspension'
  | 'electrical'
  | 'bodywork'
  | 'other';

export interface CategoryInfo {
  id: MaintenanceCategory;
  label: string;
  keywords: string[];
}

export const MAINTENANCE_CATEGORIES: CategoryInfo[] = [
  {
    id: 'mechanical',
    label: 'Mecânica',
    keywords: [
      'motor', 'transmissão', 'câmbio', 'embreagem', 'suspensão', 'freio',
      'direção', 'óleo', 'filtro', 'vela', 'correia', 'corrente', 'rolamento',
      'bomba', 'radiador', 'arrefecimento', 'injeção', 'carburador', 'escapamento',
      'diferencial', 'cardã', 'amortecedor', 'mola', 'barra', 'pivô', 'terminal'
    ]
  },
  {
    id: 'tire',
    label: 'Pneus',
    keywords: [
      'pneu', 'roda', 'aro', 'balanceamento', 'alinhamento', 'geometria',
      'calibragem', 'recape', 'câmara', 'protetor', 'válvula'
    ]
  },
  {
    id: 'suspension',
    label: 'Moleiro',
    keywords: [
      'mola', 'feixe', 'suspensão', 'amortecedor', 'barra estabilizadora',
      'pivô', 'bandeja', 'bucha', 'terminal de direção', 'coxim', 'batente',
      'kit suspensão', 'braço', 'balança'
    ]
  },
  {
    id: 'electrical',
    label: 'Elétrica',
    keywords: [
      'elétrica', 'bateria', 'alternador', 'motor de arranque', 'farol',
      'lanterna', 'seta', 'pisca', 'luz', 'iluminação', 'fiação', 'chicote',
      'sensor', 'módulo', 'central', 'buzina', 'limpador', 'vidro elétrico',
      'trava', 'alarme', 'rastreador', 'painel', 'hodômetro'
    ]
  },
  {
    id: 'bodywork',
    label: 'Funilaria e Pintura',
    keywords: [
      'funilaria', 'pintura', 'lataria', 'amassado', 'arranhão', 'riscos',
      'polimento', 'reparo', 'chapa', 'solda', 'massa', 'primer', 'verniz',
      'acabamento'
    ]
  }
];

/**
 * Categoriza um tipo de manutenção baseado em palavras-chave
 */
export function categorizeMaintenanceType(type: string | null | undefined): MaintenanceCategory {
  if (!type) return 'other';
  
  const normalizedType = type.toLowerCase().trim();
  
  for (const category of MAINTENANCE_CATEGORIES) {
    const hasKeyword = category.keywords.some(keyword => 
      normalizedType.includes(keyword)
    );
    if (hasKeyword) {
      return category.id;
    }
  }
  
  return 'other';
}

/**
 * Obtém informações sobre uma categoria
 */
export function getCategoryInfo(categoryId: MaintenanceCategory): CategoryInfo {
  return MAINTENANCE_CATEGORIES.find(c => c.id === categoryId) || {
    id: 'other',
    label: 'Outros',
    keywords: []
  };
}

/**
 * Obtém o label traduzido de uma categoria
 */
export function getCategoryLabel(categoryId: MaintenanceCategory): string {
  const category = MAINTENANCE_CATEGORIES.find(c => c.id === categoryId);
  return category?.label || 'Outras';
}

/**
 * Agrupa manutenções por categoria
 */
export function groupMaintenancesByCategory<T extends { maintenance_type?: string | null }>(
  maintenances: T[]
): Record<MaintenanceCategory, T[]> {
  const grouped: Record<MaintenanceCategory, T[]> = {
    mechanical: [],
    tire: [],
    suspension: [],
    electrical: [],
    bodywork: [],
    other: []
  };
  
  maintenances.forEach(maintenance => {
    const category = categorizeMaintenanceType(maintenance.maintenance_type);
    grouped[category].push(maintenance);
  });
  
  return grouped;
}
